import * as React from "react";
import { Callout } from "office-ui-fabric-react/lib/Callout";
import "./CalView.scss";
import { DirectionalHint } from "office-ui-fabric-react/lib/ContextualMenu";
import MeetingReportCalView from "../CRMMeeting/ReportCalItem";
import PipelineCalView from "../SSO/pipelineCalItem";
import OutlookTaskCalView from "../OutlookTask/outlookTaskCalItem";
import PlannerTaskCalView from "../PlannerTask/plannerTaskCalItem";
import EventCalItem from "../OutlookMeeting/eventCalItem";
import MSListItemBlock from '../MSList/MSListItemBlock';
import MyMIPASettingobj, { MSListItem,MSListConfig,MSListFieldValue} from "../../Entity/MySettingobj";
import Moment from "react-moment";
import { Language } from "../../Utils/Language";
import { MIAPACons } from "../../Utils/MipaConstant";
import FlagItemCalItem from '../FlaggedEmail/FlagItemCalItem';
import {OutlookEmailobj} from '../../Entity/OutlookEmailobj';
import { DateHelper } from "../../Helpers/DateHelper";
// https://www.developer.com/lang/using-html5-drag-and-drop-in-asp.net.html

export interface Props {
  crmmeetings: any;
  ssos: any;
  todos: any;
  plannertasks: any;
  outlookevents: any;
  changeview?: any;
  week: any;
  startdate: any;
  Header: any;
  extpropid;
  CreateOrCancelPreperationEvent;
  UpdateEvent;
  AcceptEvent;
  Getcrmdataforrecent;
  PrepareContactCRMReportUI;
  PrepareContactCRMSSOUI;
  GetCRMContactCompany;  
  GetContactRelatedMails;
  GetOutlookemailAttachments;
  CurrentUser;
  Users: any;
  Loadpic: any;
  PlannerUpdateData: any;
  ReloadPlannerTasks: any;

  Probability: any;
  Phases: any;
  SSOUpdateMethod: any;
  LogTitle: any;

  CRMMeetingUpdateMethod: any;
  UpdateToDoItem: any;
  UpdatePlannerTask: any;

  UserEmail: any;
  Language: any;
  InsideCRM: any;
  CRMURL: any;

  eventphrases: any;
  plannertaskphrases: any;
  SSOPhrases: any;
  TODOPhrases: any;
  MeetingReportPhrases: any;

  Progress: any;
  OverAllFilter:number;
  showweekend: boolean;

  meetingcontacts;
  ssocontacts;

  flaggedemails:any;
  flagedemailPhrases:any;
  flaggedemailupdate:any;
  taskfromflagemail;
  usertimezone;

  MySetting:MyMIPASettingobj;
  MSListUpdateMethod;
  MSListUsers;
  MSListItems:Array<MSListItem>;

  APIHeader;
  APIServiceurl;

  EmptyMessage:string;

  RefreshCRMData;
}
export interface MenuState {
  SelectOptions: Array<string>;
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;
}
export default class CalView extends React.Component<Props, MenuState, {}> {
  /*state: IProps = {
     
    };*/
  public loaded;
  public views;
  private _menuButtonElement: HTMLElement | null;
  private totalActivitytoView=0;
  constructor(props: Props) {
    super(props);
    this.loaded = false;
    let options = MIAPACons.MenuOption.options;

    this.state = {
      SelectOptions: options,
      isCalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16
    };
  }
  public preparecrmmeeting = () => {
    this.props.crmmeetings.forEach((item, index) => {
      let key = "CRMMeetingCalview_" + index;
      let duedate = new Date(item.Followup);
      if (
        item.MeetingColmn < 0 &&
        this.props.startdate > duedate &&
        this.props.startdate.toDateString() != duedate.toDateString()
      ) {
        duedate = new Date();
      }
      let dayno = duedate.getDay();
      let dataitem = { ...item };
      let meetingcontactlink=this.props.meetingcontacts[item.ContactId]?this.props.meetingcontacts[item.ContactId]:'';              
      this.views["day" + dayno].push(
        <MeetingReportCalView
          key={key}
          data={dataitem}
          UpdateMethod={this.props.CRMMeetingUpdateMethod}
          LogTitle={this.props.LogTitle}
          InsideCRM={this.props.InsideCRM}
          CRMURL={this.props.CRMURL}
          Phrases={this.props.MeetingReportPhrases}
          contactlinks={meetingcontactlink}
          RefreshCRMData={this.props.RefreshCRMData}
        />
      );
    });
  }
  public preparesso = () => {
    this.props.ssos.forEach((item, index) => {
      let key = "CRMSSOCalview_" + index;
      let duedate = new Date(item.Followup);

      if (
        item.SSOColmn < 0 &&
        this.props.startdate > duedate &&
        this.props.startdate.toDateString() != duedate.toDateString()
      ) {
        duedate = new Date();
      }
      // else {
      let dayno = duedate.getDay();
      let dataitem = { ...item };
      let SSOcontactlink=this.props.ssocontacts[item.ContactId]?this.props.ssocontacts[item.ContactId]:'';              
      this.views["day" + dayno].push(
        <PipelineCalView
          key={key}
          data={dataitem}
          Probability={this.props.Probability}
          Phases={this.props.Phases}
          UpdateMethod={this.props.SSOUpdateMethod}
          LogTitle={this.props.LogTitle}
          InsideCRM={this.props.InsideCRM}
          CRMURL={this.props.CRMURL}
          Phrases={this.props.SSOPhrases}
          contactlinks={SSOcontactlink}
          RefreshCRMData={this.props.RefreshCRMData}
        />
      );
    });
  }
  public prepareTODO = () => {
    this.props.todos.forEach((item, index) => {
      let key = "TODOCalview_" + index;
      let duedate = new Date(item.dueDateTime.dateTime);
      if (
        item.col < 0 &&
        this.props.startdate > duedate &&
        this.props.startdate.toDateString() != duedate.toDateString()
      ) {
        duedate = new Date();
      }
      // else {
      let dayno = duedate.getDay();
      let dataitem = { ...item };
      this.views["day" + dayno].push(
        <OutlookTaskCalView
          key={key}
          data={dataitem}
          UpdateToDoItem={this.props.UpdateToDoItem}
          Phrases={this.props.TODOPhrases}
          usertimezone={this.props.usertimezone}
        />
      );
    });
  }
  public preparePlanner = () => {
    this.props.plannertasks.forEach((item, index) => {
      let key = "PlannerCalView_" + index;
      let duedate = new Date(item.dueDateTime);
      if (
        item.col < 0 &&
        this.props.startdate > duedate &&
        this.props.startdate.toDateString() != duedate.toDateString()
      ) {
        duedate = new Date();
      }
      // else {
      let dayno = duedate.getDay();
      let dataitem = { ...item };
      this.views["day" + dayno].push(
        <PlannerTaskCalView
          data={dataitem}
          key={key}
          Users={this.props.Users}
          Loadpic={this.props.Loadpic}
          UpdateData={this.props.PlannerUpdateData}
          UserEmail={this.props.UserEmail}
          Language={this.props.Language}
          Header={this.props.Header}
          Phrases={this.props.plannertaskphrases}
          ReloadPlannerTasks={this.props.ReloadPlannerTasks}
          Progress={this.props.Progress}
          APIHeader={this.props.APIHeader}
          APIServiceurl={this.props.APIServiceurl}
          CurrentUser={this.props.CurrentUser}
        />
      );
    });
  }
  public prepareOutlookevent = () => {
    this.props.outlookevents.forEach((item, index) => {
      let key = "EventCalview_" + index;
      {
        let dayno = new Date(item.start.dateTime).getDay();
        this.views["day" + dayno].push(
          <EventCalItem
            key={key}
            data={item}
            phrases={this.props.eventphrases}
            extpropid={this.props.extpropid}
            UpdateEvent={this.props.UpdateEvent}
            CreateOrCancelPreperationEvent={this.props.CreateOrCancelPreperationEvent}
            AcceptEvent={this.props.AcceptEvent}
            Getcrmdataforrecent={this.props.Getcrmdataforrecent}
            PrepareContactCRMReportUI={this.props.PrepareContactCRMReportUI}
            PrepareContactCRMSSOUI={this.props.PrepareContactCRMSSOUI}
            GetCRMContactCompany={this.props.GetCRMContactCompany}
            GetContactRelatedMails={this.props.GetContactRelatedMails}
            GetOutlookemailAttachments={this.props.GetOutlookemailAttachments}
            currentuseremail={this.props.UserEmail}
          />
        );
      }
    });
  }
  public prepareFlaggedEmailcom=()=>{
    
    this.props.flaggedemails.forEach((item: OutlookEmailobj, index) => {
      let key = "FlaggedEmailCalview_" + index;
      let duedate = new Date(item.flag.dueDateTime.dateTime);
      if (item.col < 0 &&
        this.props.startdate > duedate &&
        this.props.startdate.toDateString() != duedate.toDateString()) {
          duedate = new Date();
        
      } 
      let dayno = duedate.getDay();
      this.views["day" + dayno].push(
        <FlagItemCalItem
          key={key}
          data={item}
          Phrases={this.props.flagedemailPhrases}
          UpdateMethod={this.props.flaggedemailupdate}
          taskfromflagemail={this.props.taskfromflagemail}
          usertimezone={this.props.usertimezone}
        />
      );
    });
  }
  public prepareMSListcom=()=>{
    this.props.MSListItems.forEach((item:MSListItem, index) => {
      let listinfo:MSListConfig=this.props.MySetting.ListInfo.filter((l)=>{return l.SiteURL==item.SiteUrl && l.ListTitle==item.ListTitle})[0];
      let datevalue='';
      if(listinfo.DateField!=null && listinfo.DateField.Name!=null && listinfo.DateField.Name!=''){
        datevalue=item.Fields.filter(f=>f.FieldName==listinfo.DateField.Name)[0].FieldValue;
      }
      let key = "MSListCalview_" + index;
      let duedate = new Date(datevalue);
      if (item.Col < 0 &&
        this.props.startdate > duedate &&
        this.props.startdate.toDateString() != duedate.toDateString()) {
          duedate = new Date();
        
      } 
      
      let dayno = duedate.getDay();
      this.views["day" + dayno].push(
        <div
        className="CalMSListContainer"
        draggable
        onDragStart={e => this.onMSListDragStart(e,item,listinfo)}
      >
        <MSListItemBlock key={key}
      ListInfo={listinfo}
      ListItem={item}
      UserEmail={this.props.UserEmail}
      Users={this.props.MSListUsers[listinfo.ID]}
      UpdateMethod={this.props.MSListUpdateMethod}
      >

      </MSListItemBlock>
      </div>
        
      );
      
    });
  }
  public onMSListDragStart = (ev,dataitem:MSListItem,listinfo:MSListConfig) => {
    
    let dragdata = {
      id: dataitem.ID,
      type: "mslist",
      colno: dataitem.Col,
      property: listinfo.DateField.Name,
      source: ev.target.parentElement.id,
      listinfo:listinfo
    };
    ev.dataTransfer.setData("text/plain", JSON.stringify(dragdata));
    /*
        ev.dataTransfer.setData("id", this.props.data.ID.toString());
        ev.dataTransfer.setData("type", 'crmmeeting');
        ev.dataTransfer.setData("colno", this.props.data.MeetingColmn.toString());
        ev.dataTransfer.setData("property", 'MeetRepFollow');
        ev.dataTransfer.setData("source", ev.target.parentElement.id);
        */
    /*ev.dataTransfer.setData("text/plain",this.props.data.ID);
        ev.dataTransfer.setData("text/plain", 'crmmeeting');*/
  };
  public preparedays = () => {

    let firstdate = DateHelper.GetFirstDayOfWeek(this.props.startdate, 1);
    this.views.dates.push(firstdate.toString());

    firstdate.setDate(firstdate.getDate() + 1);
    this.views.dates.push(firstdate.toString());

    firstdate.setDate(firstdate.getDate() + 1);
    this.views.dates.push(firstdate.toString());

    firstdate.setDate(firstdate.getDate() + 1);
    this.views.dates.push(firstdate.toString());

    firstdate.setDate(firstdate.getDate() + 1);
    this.views.dates.push(firstdate.toString());

    if (this.props.showweekend) {

      firstdate.setDate(firstdate.getDate() + 1);
      this.views.dates.push(firstdate.toString());
      
      firstdate.setDate(firstdate.getDate() + 1);
      this.views.dates.push(firstdate.toString());
    }
  }
 
  public render() {   
    this.views = {
      overdue: [],
      day1: [],
      day2: [],
      day3: [],
      day4: [],
      day5: [],
      day6: [],
      day0: [],
      dates: []
    };
    this.totalActivitytoView=0;
    this.loaded = true;
    this.preparedays();
    let showMeeting=(this.props.OverAllFilter < 0 && this.state.SelectOptions.indexOf("Meetings") >= 0) || this.props.OverAllFilter == 2?true:false;
    let showsso=(this.state.SelectOptions.indexOf("SSO") >= 0 && this.props.OverAllFilter < 0) || this.props.OverAllFilter == 3?true:false;
    let showplannertask=(this.state.SelectOptions.indexOf("PlannerTask") >= 0 && this.props.OverAllFilter < 0) || this.props.OverAllFilter == 0?true:false;
    let showevents=(this.state.SelectOptions.indexOf("Events") >= 0 && this.props.OverAllFilter < 0) || this.props.OverAllFilter == 1?true:false;
    let showtodo=(this.state.SelectOptions.indexOf("TODOS") >= 0 && this.props.OverAllFilter < 0) || this.props.OverAllFilter == 4?true:false;
    let showflaggedemail=(this.props.OverAllFilter < 0) || this.props.OverAllFilter == 5?true:false;
    let showMSList=(this.props.OverAllFilter < 0) || this.props.OverAllFilter == 6?true:false;
    if (showMeeting) {
      this.totalActivitytoView +=this.props.crmmeetings.length;
      this.preparecrmmeeting();
    }
    if (showsso) {
      this.totalActivitytoView +=this.props.ssos.length;
      this.preparesso();
    }
    if (showplannertask) {
      this.totalActivitytoView +=this.props.plannertasks.length;
      this.preparePlanner();
    }
    if (showevents) {
      this.totalActivitytoView +=this.props.outlookevents.length;
      this.prepareOutlookevent();
    }
    if (showtodo) {
      this.totalActivitytoView +=this.props.todos.length;
      this.prepareTODO();
    }
    if(showflaggedemail) {
      this.totalActivitytoView +=this.props.flaggedemails.length;
      this.prepareFlaggedEmailcom();
    }
    if(showMSList) {
      this.totalActivitytoView +=this.props.MSListItems.length;
      this.prepareMSListcom();
    } 
    var widthcss = {
      width:
        (this.props.showweekend
          ? 284 * 7
          : 284 * 5) + "px"
    };
    let rowcss = "row1 ms-Grid-row";
    // let overduerow = "row ms-Grid-row overdue";
    const { isCalloutVisible, beakWidth } = this.state;
    let buttoncss = [
      "selectedmenu",
      "ms-Button ms-Button--action ms-Button--command buttonroot"
    ].join(" ");
    return (
      <div className="calview ms-Grid">
        <button 
              style={{display:'none'}}
              className={buttoncss}
              type="button"
              ref={menuButton => (this._menuButtonElement = menuButton)}
              onClick={this._onMenuClicked}
        >
          <div>
            <span>
              {Language.GetLanguageValue(this.props.Language, "options")}{" "}
            </span>
            <i className="ms-Icon ms-Icon--ChevronDown x-hidden-focus" />
          </div>
        </button>
        {isCalloutVisible ? (
          <Callout
            className="ms-Callout-callout"
            onDismiss={this._onCalloutDismiss}
            target={this._menuButtonElement}
            directionalHint={DirectionalHint.topAutoEdge}
            coverTarget={false}
            isBeakVisible={true}
            gapSpace={0}
            beakWidth={beakWidth}
          >
            <div className="detailcallout1">
              <div className="ms-Callout-inner" style={{ padding: "10px" }}>
                <div className="ms-Callout-content ms-Grid menugrid">
                  {this.GetDropDownmenu().map((element, keyIndex) => {
                    return (
                      <div
                        className="ms-Grid-row"
                        key={"Calviewmenu_" + keyIndex}
                      >
                        {this.PreparemenuItems(element)}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </Callout>
        ) : null}
        <div
          style={{
            maxWidth: "100%",
            overflow: "auto",
            minHeight: "calc(100vh - 100px)"
          }}
        >
          <div style={widthcss}>
            <div className={rowcss}>
              {this.totalActivitytoView>0? this.views.dates.map((el, index) => {
                let headingkey = "calheading" + index;
                return (
                  <div
                    key={headingkey}
                    className="ms-Grid-col mipacolseg7 firstcol ms-Label"
                    title={el.toString()}
                  >
                    <Moment format="ddd (DD)">{el.toString()}</Moment>
                  </div>
                );
              }):<span className="emptymessageblock">{this.props.EmptyMessage}</span>}
            </div>
            <div className={rowcss}>
              {this.views.dates.map((el, index) => {
                let dayindex = (index + 1) % 7;
                let divid = "Dropablediv_" + index;
                return (
                  <div
                    key={divid}
                    id={divid}
                    className="ms-Grid-col  mipacolseg7 secondcol"
                    onDragOver={e => this.onDragOver(e)}
                    onDrop={e => {
                      this.onDrop(e, el);
                    }}
                  >
                    {" "}
                    {this.views["day" + dayindex]}
                  </div>
                );
              })}
            </div>
            <div style={{ clear: "both" }}>&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }
  /*public PreparemenuItems = (): IContextualMenuItem[] => {
        let menus = [];

        let menuitems = this.GetDropDownmenu();
        menuitems.forEach((element, keyIndex) => {
            let displayName = element.display;

            let menu = {
                key: 'Cal_heading_' + "_" + keyIndex,
                name: displayName,
                iconProps: {
                    className: this.state.SelectOptions.indexOf(element.type) >= 0 ? 'ms-Icon ms-Icon--Accept' : ''
                },
                onClick: (evt, item) => {
                    let prevoptions = this.state.SelectOptions;
                    let index = prevoptions.indexOf(element.type);
                    if (index >= 0) {
                        prevoptions.splice(index, 1);
                    }
                    else {
                        prevoptions.push(element.type);
                    }
                    this.setState({ SelectOptions: prevoptions });                    
                }
            };
            menus.push(menu);
        });
        return menus;
    }*/
  public PreparemenuItems = element => {
    let activehtml = (
      <i style={{ opacity: 0 }} className="ms-Icon ms-Icon--Accept" />
    );
    if (this.state.SelectOptions.indexOf(element.type) >= 0 || this.props.OverAllFilter>=0) {
      activehtml = <i className="ms-Icon ms-Icon--Accept" />;
    }
    let menuitemoption = (
      <div
        className="ms-Grid-col ms-sm12"
        onClick={() => {
          let prevoptions = this.state.SelectOptions;
          let index = prevoptions.indexOf(element.type);
          if (index >= 0) {
            prevoptions.splice(index, 1);
          } else {
            prevoptions.push(element.type);
          }
          this.setState({ SelectOptions: prevoptions });
        }}
      >
        {activehtml} {element.display}
      </div>
    );
    return menuitemoption;
  }
  public GetDropDownmenu = (): Array<any> => {
    let items = [
      {
        type: "Meetings",
        display: Language.GetLanguageValue(this.props.Language, "meetingreport")
      },
      {
        type: "SSO",
        display: Language.GetLanguageValue(this.props.Language, "opportunity")
      },
      {
        type: "PlannerTask",
        display: Language.GetLanguageValue(this.props.Language, "plannertask")
      },
      {
        type: "Events",
        display: Language.GetLanguageValue(this.props.Language, "meeting")
      },
      {
        type: "TODOS",
        display: Language.GetLanguageValue(this.props.Language, "todo")
      }
    ];
    /*if (this.props.week == 1) {
            items.push({ type: "Overdue", display: Language.GetLanguageValue(this.props.Language,'overdue') });
        }*/
    /*items.push({
      type: "showweekend",
      display: Language.GetLanguageValue(this.props.Language, "showweekend")
    });*/
    return items;
  }
  
  public onDragOver = event => {
    /*ev.preventDefault();

        ev.stopPropagation();*/
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch(ex) {
        console.error(ex);
    }
  }
  public onDrop = (ev, date) => {
    ev.preventDefault();
    ev.stopPropagation();
    let dropdata = JSON.parse(ev.dataTransfer.getData("text/plain"));
    let soourceid = dropdata["source"];
    if (soourceid == ev.currentTarget.id) {
      return;
    }
    // event.currentTarget.style.background = '#7f8082';

    /*let dataid = ev.dataTransfer.getData("id");
        let type = ev.dataTransfer.getData("type");
        let Col =parseInt(ev.dataTransfer.getData("colno"));
        let Property = ev.dataTransfer.getData("property");*/
    let dataid = dropdata["id"];
    let type = dropdata["type"];
    let Col = dropdata["colno"];
    let Property = dropdata["property"];
    let obj = {};
    let datevalue = new Date(date);
    switch (type) {
      case "crmmeeting":
        obj = {
          listtitle: "CRM Meeting Report",
          ID: dataid,
          fieldslist: [
            {
              spfieldname: Property,
              spvalue: DateHelper.GetDateStringIn_yyyy_mm_dd_format(datevalue) + "T10:37:00Z",
              spfieldtype: "DateTime"
            }
          ]
        };
        this.props.CRMMeetingUpdateMethod(obj, Col, false);
        break;
      case "pipeline":
        obj = {
          listtitle: "SSO List",
          ID: dataid,
          fieldslist: [
            {
              spfieldname: Property,
              spvalue: DateHelper.GetDateStringIn_yyyy_mm_dd_format(datevalue) + "T10:37:00Z",
              spfieldtype: "DateTime"
            }
          ]
        };
        this.props.SSOUpdateMethod(obj, Col, true);
        break;
      case "plannertask":
        let etag = dropdata["etag"];
        obj[Property] = DateHelper.GetDateStringIn_yyyy_mm_dd_format(datevalue) + "T10:37:00Z";
        this.props.UpdatePlannerTask(dataid, obj, etag, Col);
        break;
      case "outlooktask":
        obj = {
          dueDateTime: {
            dateTime: DateHelper.GetDateStringIn_yyyy_mm_dd_format(datevalue) + "T10:37:00Z",
            //timeZone: Helper.getTimeZoneId()
            timeZone: this.props.usertimezone
          }
        };
        this.props.UpdateToDoItem(dataid, obj, Col);
        break;
        case "mslist":
         let ListInfo:MSListConfig=dropdata["listinfo"];
          let fielddata:MSListFieldValue={
            FieldTitle:'',
              FieldName:Property,
              FieldValue: DateHelper.GetDateStringIn_yyyy_mm_dd_format(datevalue) + "T10:37:00Z",
              FieldType:'DateTime',
            IDValue:dataid
          };
          let config={
            SiteURL:ListInfo.SiteURL,
            ListTitle:ListInfo.ListTitle,
            UserEmail:this.props.UserEmail
          };
          this.props.MSListUpdateMethod(config,[fielddata]);
        break;
      default:
        return;
    }
    // let date = DateHelper.GetDateStringIn_yyyy_mm_dd_format(val)+ "T10:37:00Z";
    /*

        this.props.UpdateMethod(obj,col,false);
        */
  }
  private _onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false
    });
  }

  private _onMenuClicked = (): void => {
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  }
}

